export async function APICalls(apiUrl: any, methodType: any, inputParam?: any) {
  try {
    
    let response = await fetch(apiUrl, {
      method: methodType,
      body: inputParam,
    });
    
    return await response.json();
  } catch (error) {
    
    return JSON.stringify(error);
  }
}
 